const pic_01 = require("@/assets/images/mechanis/01_zongbu.png")
const pic_02 = require("@/assets/images/mechanis/02_zhonghuanengyuan.png")
const pic_03 = require("@/assets/images/mechanis/pic_03.png")
const pic_04 = require("@/assets/images/mechanis/pic_04.png")
const pic_05 = require("@/assets/images/mechanis/pic_05.png")
const pic_06 = require("@/assets/images/mechanis/06_zhongguohaohua.png")
const pic_07 = require("@/assets/images/mechanis/pic_07.jpg")
const pic_08 = require("@/assets/images/mechanis/08_cangzhoudahua.png")
const pic_09 = require("@/assets/images/mechanis/09_huagongxiangjiao.png")
const pic_10 = require("@/assets/images/mechanis/pic_10.jpg")
const pic_11 = require("@/assets/images/mechanis/pic_11.jpg")
const pic_12 = require("@/assets/images/mechanis/pic_12.png")
const pic_13 = require("@/assets/images/mechanis/pic_13.png")
const pic_14 = require("@/assets/images/mechanis/pic_14.png")
const pic_15 = require("@/assets/images/mechanis/15_hangjituan.png")
const pic_16 = require("@/assets/images/mechanis/pic_16.png")
const pic_17 = require("@/assets/images/mechanis/pic_17.png")
const pic_18 = require("@/assets/images/mechanis/18_zhonghuacaiwu.png")
const pic_19 = require("@/assets/images/mechanis/pic_19.jpg")
const pic_20 = require("@/assets/images/mechanis/pic_20.png")
const pic_21 = require("@/assets/images/mechanis/pic_21.png")
const pic_22 = require("@/assets/images/mechanis/pic_22.png")
const domain = 'https://wecruit.hotjob.cn'
const suiteKey = 'SU611a641a0dcad4106f04950e'

export const mechanisList = [
    {
        title: '中国中化控股有限责任公司',
        img_url: pic_01,
        isActive: true,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F3`,
        content: [
            '中国中化控股有限责任公司（简称中国中化，英文简称Sinochem Holdings）是由中国中化集团有限公司与中国化工集团有限公司联合重组而成，于2021年5月8日正式揭牌成立，为国务院国资委监管的国有重要骨干企业。业务范围覆盖生命科学、材料科学、石油化工、环境科学、橡胶轮胎、机械装备、城市运营、产业金融等八大领域。中国中化坚持“世界一流综合性化工企业”的战略定位，聚焦助力农业高质量发展、助推化工新材料补短板等核心功能，着力推动产业、科技、数智、治理、国际化经营五大变革，打造具有全球竞争力的国家级农业科技平台和化工新材料产业平台。',
        ],
    },
    {
        title: '中化能源股份有限公司',
        img_url: pic_02,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F4`,
        content: [
            '中化能源是中国中化旗下负责石油化工业务的专业公司，深耕石油化工领域70余年，构建了包含炼油化工、石油贸易及服务、油品及化工品销售、仓储物流等全产业链协同体系。通过不断扩展炼化产业链、垂直延伸产品链，提升核心竞争力与可持续发展能力，立足国内，布局全球，持续扩大石油及石化产品贸易营销网络、完善仓储物流布局，为客户提供优质综合服务。积极履行国家能源安全保障使命，着力构建绿色低碳、创新驱动、协同高效的现代石化产业体系，致力于成为国家能源化工行业高质量、可持续发展的践行者。',
        ],
    },
    {
        title: '先正达集团中国',
        img_url: pic_03,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F7`,
        content: [
            '先正达集团中国是中国领先的农业科技全球化企业，是先正达集团旗下四大业务单元之一。公司立足中国市场，业务覆盖种子、植保和现代农业服务等业务领域。秉持“让现代农业惠及更多农民和消费者”的使命，致力于成为“最具创新力的中国农业科技全球化公司”，公司依托强大的科技创新能力和产业链协同优势，聚焦作物单产提升和产品品质改善, 为中国农业现代化贡献解决方案，加快推动中国农业高质量发展。',
        ],
    },
    {
        title: '中化化肥有限公司',
        img_url: pic_22,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F219`,
        content: [
            '中化化肥是中国中化旗下作物营养业务核心战略运营主体。作为国内化肥行业首家在港上市企业，公司既是钾肥商业储备核心承担者，也是中国领先的农资投入品分销服务商，其业务覆盖资源、研发、生产、分销、零售、农技服务全产业链。公司秉承“科技赋能耕作，永续农业美好”的发展理念，以“成为作物营养健康引领者，携手亿万农人，缔造丰沃大地”为愿景，践行保供稳价央企责任担当，全力筑牢粮食安全防线。',
        ],
    },
    {
        title: '化工事业部',
        img_url: pic_04,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F8`,
        content: [
            '化工事业部是中国中化材料科学核心主业的承担者，在新材料及中间体、聚合物添加剂等领域具有核心竞争力，是中国领先的化工新材料产品综合服务商，客户遍及全球100多个国家和地区。',
            '化工事业部以“精细化学 绿色生活”为愿景，持续聚焦化工新材料核心主业，以产业链思维和一体化产业布局进行战略转型，聚焦环氧树脂、聚合物添加剂、工程塑料、芳纶等核心产业链，打造技术领先、具有核心竞争力的新材料产业集群，致力于成为世界级的材料科学平台。',
        ],
    },
    {
        title: '中国蓝星（集团）股份有限公司',
        img_url: pic_05,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F1294`,
        content: [
            '中国蓝星（集团）股份有限公司是中国中化旗下全球领先的化工新材料和特种化学品公司，目前在全球拥有30个主要生产基地，20所科研机构，国际化员工数量占比超过40%。蓝星有机硅是全球有机硅市场的领导者之一，面向电子、汽车、建筑、医疗等重点领域为全球客户提供有机硅创新材料解决方案；蓝星公司旗下安迪苏是全球液体蛋氨酸第一大生产商，为世界各地畜禽和水产养殖场升级饲料营养。',
            '面向未来，蓝星公司将持续深化创新驱动、绿色发展、国际合作的战略，重点布局新能源材料、生物化工、循环经济等新兴领域，致力于成为具有全球竞争力的世界一流化工企业。',
        ],
    },
    {
        title: '中国昊华化工集团有限公司',
        img_url: pic_06,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F769`,
        content: [
            '中国昊华化工集团有限公司是在化学工业部党组关怀下，1994年经国务院批复设立的大型国有化工集团，2018年实现整体上市。公司是中国中化控股有限责任公司的专业公司，主要从事氟化工、电子化学品、高端制造化工材料的研发与生产，以及提供绿色低碳整体方案的碳减排业务。公司拥有几十年深厚的技术沉淀，具有较强的科技创新、成果转化、工程设计、项目总包和技术服务优势。公司始终把“致力成为中国先进化工材料行业引领者，持续为人类品质生活提升和技术进步作贡献”作为发展战略和发展愿景；以“科学至上”为指引，坚持“科技引领，创新驱动，追求卓越”，持续推进公司高质量发展。',
        ],
    },
    {
        title: '鲁西集团有限公司',
        img_url: pic_07,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F1362`,
        content: [
            '鲁西集团是国有控股企业，于1976年建成，2020年加入中国中化控股有限责任公司（简称中国中化），职工12000余人。涵盖煤化工、盐化工、氟化工、硅化工、化工新材料等，年产化工产品1000万吨，产品除国内销售外，还远销欧美及东南亚等国家和地区，各种产品市场用途广泛，发展前景广阔。主要生产聚碳酸酯、己内酰胺、尼龙6、双氧水、多元醇、甲酸、高端新型制冷剂、有机硅、甲烷氯化物、烧碱、甲醇等百余类产品，目前总资产353亿元。 ',
        ],
    },
    {
        title: '沧州大化集团有限责任公司',
        img_url: pic_08,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F1018`,
        content: [
            '沧州大化集团有限责任公司是中国中化控股有限责任公司旗下二级公司，始建于1973年，2000年成功上市，股票代码600230。公司坐落于美丽的渤海之滨-河北沧州，现有16万吨TDI、10万吨PC、20万吨双酚A、16万吨离子膜烧碱、13.5万吨硝酸、1.2万吨/年人造革的生产能力。荣获全国五一劳动奖状、全国先进基层党组织、全国十大管理模式创新领先企业、聚氨酯产业领军企业、全国石油和化学工业环境保护先进单位、全国石油和化工行业两化融合优秀实践奖、中国化工行业卓越品牌、国家863计划CIMS应用示范企业。',
        ],
    },
    {
        title: '氯碱事业部',
        img_url: pic_12,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F772`,
        content: [
            '中国中化氯碱事业部成立于2022年11月，是中国中化核心战略实施平台之一，管理沈阳化工、德州实华等9家企业，业务范围涉及氯碱化工、聚醚多元醇、氯丁橡胶、原料药、钛白粉等领域，昊华海通为事业部原材料集采和产品集销平台。',
            '事业部拥有先进的生产基地、研发设施及完善的营销体系，是国内最大的烧碱和PVC树脂生产商之一，总体规模水平均居于全国第二，其中PVC糊树脂产能亚洲第一；聚醚多元醇是聚醚行业唯一“知名品牌”；氯丁橡胶占国内总产能的50%。',
        ],
    },
    {
        title: '中国化工橡胶有限公司',
        img_url: pic_09,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F771`,
        content: [
            '中国化工橡胶有限公司是中国中化旗下全球领先的轮胎制造商和中国领先的橡胶制品制造商，在全球12个国家设有25家生产基地，16个全球研发机构，产品销往全球160多个国家和地区。公司主要从事乘用轮胎(包括轿车和SUV轮胎、摩托车轮胎、自行车轮胎等)、工业用轮胎(包括卡客车轮胎、工程机械轮胎、农用车轮胎等)和橡胶输送带等产品的研发、生产、销售和服务。',
            '公司参股倍耐力股份有限公司（PIRC.MI），并控股拥有风神轮胎股份有限公司（600469.SH）、Promenton Tyre Group S.R.L.（简称PTN或百得安，是原倍耐力工业用轮胎资产分拆成立的国际知名工业用轮胎企业）和青岛橡六输送带有限公司等下属企业。',
        ],
    },
    {
        title: '中国化工装备有限公司',
        img_url: pic_10,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F775`,
        content: [
            '中国化工装备有限公司是国务院国资委监管的国有重要骨干企业中国中化控股有限责任公司旗下二级公司，下属企业包括克劳斯玛菲集团、天华化工机械及自动化研究设计院有限公司、中化(福建)橡塑机械有限公司和蓝星(北京)化工机械有限公司，为全球客户提供全面的塑料机械、化工装备、橡胶机械和新能源装备产品和技术服务方案，帮助客户实现高端化、智能化、绿色化发展，正积极打造“材料+装备+产品”新材料应用生态圈，致力于成为世界一流的智能装备制造与综合解决方案服务商。旗下上市公司中化装备科技(青岛)股份有限公司，代码600579。',
        ],
    },
    {
        title: '中化环境控股有限公司',
        img_url: pic_11,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F65`,
        content: [
            '中化环境是中国中化控股有限责任公司发展环境科学的专业公司。',
            '中化环境充分发挥公司矿山行业及膜领域的深厚底蕴和技术能力，保障集团主业，服务国家战略，业务涵盖膜及膜应用、矿山资源开发及循环利用、清洗服务、工业水处理、盐碱地综合利用五大领域，提供从咨询、设计到建设、运营一体化的智慧化综合解决方案。',
            '公司拥有国家液体分离膜工程技术研究中心等14个省部级以上研发平台，累计获得国家级科技奖项20项，其中国家科技进步一等奖5项，拥有900项专利。公司拥有1名中国工程院院士、3名国家/行业勘察设计大师、16名国务院特殊津贴专家。',
        ],
    },
    {
        title: '中国金茂控股集团有限公司',
        img_url: pic_13,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F55`,
        content: [
            '中国金茂控股集团有限公司是中国中化旗下城市运营领域的平台企业，于2007年在香港联交所主板上市。中国金茂持续推进“一核·三聚焦”发展战略，形成以高品质开发为核心，聚焦精品持有、品质服务和建筑科技多维业务联动体系，致力于成为地产行业产品引领者，转型发展优等生。',
            '中国金茂深度布局京津冀、长三角、粤港澳大湾区、长江经济带、成渝经济圈等中国最具发展活力的区域，销售规模与综合实力稳居行业第一梯队。“金茂”品牌已成为“中国驰名商标”，打造了以“金玉满堂”为代表的住宅产品线、以“金茂中心”“览秀城”“金茂璞修”为代表的资产运营管理产品线。',
        ],
    },
    {
        title: '中化资本有限公司',
        img_url: pic_14,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F2`,
        content: [
            '中化资本是中国中化产融服务和投资平台。业务涵盖信托、融资租赁、公募基金、人寿保险、产业基金、商业保理、保险经纪、期货、综合商务服务、金融科技等领域，培育出“中国外贸信托”“中宏保险”“诺安基金”“中化商务”“中化保理”“中化资本创投”“中化保险经纪”等在行业内具有较强竞争力和影响力的品牌，整体风险控制能力和盈利能力均位于行业前列。',
            '中化资本持续做实做好科技金融、绿色金融、普惠金融、养老金融、数字金融“五篇大文章”，矢志打造行业领先、受人尊敬的产业金融综合服务商。',
        ],
    },
    {
        title: '中化香港（集团）有限公司',
        img_url: pic_15,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F1385`,
        content: [
            '中化香港（集团）有限公司（简称中化香港集团）于1989年在香港注册成立，注册资本244.68亿港币，由中国中化控股有限责任公司（简称中国中化）间接持有100%股权。中化香港是中国中化的二级直管单位，公司定位为中国中化的境外投融资控股平台，承担境外股权投资、境外融资、全球资金集中管理和资产管理的职责。其下控股公司主要包括中国金茂控股有限公司（HK.00817），中化欧洲集团公司、中化亚洲集团公司、中化香港石油国际有限公司和中化海外贸易有限公司等。',
        ],
    },
    {
        title: '沈阳化工研究院有限公司',
        img_url: pic_16,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F53`,
        content: [
            '沈阳化工研究院有限公司始建于1949年1月8日，是综合性化工科研院所。1999年5月，转制为中央直属大型科技企业。2007年4月，与中国中化集团公司重组，现为中国中化控股有限责任公司直管单位。',
            '主要开展化工安全、化工过程强化、化工新材料开发及应用测试、生物化工、化学品测试与评价等方向的研究及产业化。累计取得3000余项科研成果，完成国家重点科技攻关项目160余项，制修订国家、行业标准1000余项，获各级科技奖励430余项。',
            '面向未来，将沈阳院打造成为“研产销一体”的一流科研创新型企业，为中国中化建设世界一流综合性化工企业贡献沈阳院力量！',
        ],
    },
    {
        title: '中蓝晨光化工研究设计院有限公司',
        img_url: pic_17,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F1299`,
        content: [
            '中蓝晨光院始建于1965年，原化工部十大重点院所之一，现为中国中化直管单位，位于四川省成都市。主要从事有机硅及特种氟、改性塑料及助剂、特种有机纤维、特种环氧树脂等新材料的科研生产，以及工程化研究、分析测试和信息服务。是“国家有机硅工程技术研究中心”“国家受力结构工程塑料工程技术研究中心”“国家合成树脂质量监督检验中心”“国际标准组织塑料标准化委员会秘书处”等多个国家级技术机构的依托单位，拥有《塑料工业》《有机硅材料》期刊，科研实力处于国内先进水平。',
        ],
    },
    {
        title: '中化集团财务有限责任公司',
        img_url: pic_18,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F62`,
        content: [
            '中化集团财务有限责任公司是经中国银保监会批准设立的非银行金融机构，注册资本60亿元。财务公司坚定落实总部战略要求，在明确“辅助管理、金融服务”两个属性基础上，扎实推动“资金归集、资金结算、资金监控、金融服务”四个平台功能建设，全力打造中国中化全球一体化司库管理体系，以集团整体利益最大化为目标，服务集团战略、助力主业发展。财务公司视人力资源为第一资源，重点围绕“多渠道招聘、系统化培养、全方位激励”等开展工作，努力打造结构合理、规模适度、能力匹配的人才队伍。',
        ],
    },
    {
        title: '中化资产管理有限公司',
        img_url: pic_19,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F61`,
        content: [
            '中化资产依托中国中化强大的产业背景，深耕企业不良资产经营处置领域，在问题企业救助、产业咨询、资产处置等方面积攒了丰富的经验。在中国经济结构转型升级、金融回归服务实体经济的大背景下，中化资产聚焦企业、金融机构和政府三类客户需求，致力于用“实现社会价值最大化”新理念引领资产管理行业发展，整合强大的央企产业、金融、管理资源，提供六种专业服务，连接产业和金融，帮助实体企业脱困转型，助力金融机构消解不良资产，协助地方政府引导经济社会实现新旧动能转换。',
        ],
    },
    {
        title: '中国化工信息中心有限公司',
        img_url: pic_20,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F1324`,
        content: [
            '中国化信系化工行业国家级信息研究机构，经过60多年的发展，中国化信继承和发扬信息资源和专家团队等资源优势，跟踪国内外化工发展趋势，面向各类客户需求，提供产业规划、专业园区规划、投资机会分析、市场调研、专利查新、HSE咨询、双碳咨询、竞争情报、标准修制订等服务，已成为全国化工行业知名的咨询和信息服务机构。',
            '中国化信围绕“为国家建言献策，为集团谋篇布局，为行业洞察赋能”的战略目标，正全力打造全球领先的化工行业新型高端智库。',
        ],
    },
    {
        title: '中化数智科技有限公司',
        img_url: pic_21,
        isActive: false,
        toUrl: `${domain}/${suiteKey}/mc/position/campus?orgCode=0%2F5`,
        content: [
            '中化数智成立于2017年，为央企中国中化直属数字化科技企业，主营产业数字化全链条服务，赋能化工、农业智能化转型。公司设北京、雄安双总部，多地布局分支机构，配套智能制造专业子公司；自有员工300余人，外聘顾问500 余人，团队高学历、专业适配度强。企业拥有高新、双软等资质，集齐多类ISO体系、CMMI5、DCMM3认证，自研产品拥有数百项软件著作权。践行新时代中国中化“精气神”，秉承“客户为先 创新为要 奋斗为本”优良传统，深耕前沿技术，持续输出数字化智能解决方案。',
        ],
    },
]